@if (config().visible) {
  <div class="row" [formGroup]="formGroup">
    <mat-form-field [ngClass]="config().styleClass">
      <mat-label [ngClass]="config().labelClass" [attr.for]="config().attrName">{{ config().label }}</mat-label>
      <textarea matInput [id]="config().attrName" formControlName="{{ config().attrName }}" placeholder="Ex. It makes me feel..."></textarea>
    </mat-form-field>
  </div>
}
